import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';

import React from 'react';
import { Redirect } from 'react-router-dom';

import ErrorBox from '../components/ErrorBox';

const actionCodeSettings = {
  url: new URL('/login', window.location).href,
  handleCodeInApp: true,
};

class Auth extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      email: '',
      emailSent: false,
      confirmingEmail: false,
      confirmingContributor: false,
    }
  }

  componentDidMount () {
    if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
      this.validateAuth();
    }
  }

  render () {
    return (
      <div>
        {this.props.user &&
          <Redirect to="/review" />}

        <h1>Who art thou?</h1>
        <p>We need to know if you're one of the chosen reviewers or not.</p>

        {!this.state.loggingIn && this.props.location.state && this.props.location.state.error &&
          <ErrorBox>{this.props.location.state.error.message}</ErrorBox>}

        {this.state.confirmingEmail
          ? 'Checking verification code...'
          : this.state.confirmingContributor
          ? 'Checking to make sure this email belongs to someone on the committee...'
          : this.state.emailSent
          ? 'Email verification sent. Please check your inbox!'
          : <form onSubmit={this.requestLoginEmail}>
              <input type="text" onChange={this.updateEmail} placeholder="email" value={this.state.email} />
              <button type="submit">Start Reviewin!</button>
            </form>}
      </div>
    )
  }

  updateEmail = (e) =>
    this.setState({email: e.target.value});

  requestLoginEmail = (e) => {
    e.preventDefault();

    firebase.auth().sendSignInLinkToEmail(this.state.email, actionCodeSettings)
      .then(() => {
        this.setState({emailSent: true});
        window.localStorage.setItem('emailForSignIn', this.state.email);
      })
      .catch((error) => {
        this.setState({emailSent: false});
        console.error(error);
      });
  }

  validateAuth = () => {
    this.setState({confirmingEmail: true});
    const email =
      window.localStorage.getItem('emailForSignIn')
      || window.prompt('Please provide your email for confirmation');

    firebase.auth().signInWithEmailLink(email, window.location.href);
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/pages/Auth.jsx